(function () {
  const state = {
    trackingValue: 'oui',
    pdpPreorderIds: new Set(),
  };

  function isVariantPreorder(form, variantId) {
    if (state.pdpPreorderIds.has(variantId)) return true;

    const productForm = form.closest('product-form[data-preorder-variants]');
    if (!productForm) return false;

    const ids = productForm.dataset.preorderVariants
      .split(',')
      .map((s) => parseInt(s.trim(), 10))
      .filter((n) => !isNaN(n));

    return ids.includes(variantId);
  }

  function syncForm(form) {
    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;

    const variantId = parseInt(variantInput.value, 10);
    const isPreorder = isVariantPreorder(form, variantId);

    const selector = 'input[name="properties[_precommande]"][data-precommande-tracker]';
    let existing = form.querySelector(selector);

    if (isPreorder) {
      if (!existing) {
        existing = document.createElement('input');
        existing.type = 'hidden';
        existing.name = 'properties[_precommande]';
        existing.setAttribute('data-precommande-tracker', '');
        form.appendChild(existing);
      }
      existing.value = state.trackingValue;
    } else if (existing) {
      existing.remove();
    }
  }

  function syncAllForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(syncForm);
  }

  function bindEvents() {
    document.addEventListener(
      'change',
      (e) => {
        const form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
        if (form) queueMicrotask(() => syncForm(form));
      },
      true
    );

    document.addEventListener(
      'submit',
      (e) => {
        if (e.target.matches && e.target.matches('form[action*="/cart/add"]')) {
          syncForm(e.target);
        }
      },
      true
    );

    document.addEventListener(
      'click',
      (e) => {
        const btn = e.target.closest && e.target.closest('button[name="add"], [type="submit"]');
        if (!btn) return;
        const form = btn.closest('form[action*="/cart/add"]');
        if (form) syncForm(form);
      },
      true
    );
  }

  if (!customElements.get('precommande-tracker')) {
    class PrecommandeTracker extends HTMLElement {
      connectedCallback() {
        const dataEl = this.querySelector('script[type="application/json"]');
        if (!dataEl) return;

        try {
          const data = JSON.parse(dataEl.textContent);
          state.trackingValue = data.value || state.trackingValue;
          (data.variants || [])
            .filter((v) => v.preorder)
            .forEach((v) => state.pdpPreorderIds.add(v.id));
          syncAllForms();
        } catch (err) {
          console.warn('[precommande-tracker] JSON invalide', err);
        }
      }
    }
    customElements.define('precommande-tracker', PrecommandeTracker);
  }

  bindEvents();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllForms);
  } else {
    syncAllForms();
  }
})();
